import { getLocalLog } from './reporter';
import { getLocalAppAnalyzeRecord } from './appAnalyzeUtils';
import { getUserId, getProductName } from './metaData';
import { safeJsonStringify } from './utils';

// const UPLOAD_URL = 'http://localhost:8081/file-upload'
const UPLOAD_URL = 'https://docs-h2.corp.kuaishou.com/tools/storage';

function sendFile(record: any) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', UPLOAD_URL);
    xhr.setRequestHeader('Content-Type', 'application/json');
    try {
      xhr.send(
        safeJsonStringify({
          name: `${getUserId() || 'anonymous'}-${getProductName()}`,
          record
        })
      );
    } catch (e) {
      reject(false);
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        try {
          const res = JSON.parse(xhr.response);
          if (res.code === 0) {
            resolve(true);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(false);
        }
      }
    };
  });
}

/**
 *
 */
export function sendLog() {
  return sendFile({
    localLog: getLocalLog(),
    localAppAnalyze: getLocalAppAnalyzeRecord()
  });
}

/**
 *
 */
export function sendAppAnalyze() {
  return sendFile(getLocalAppAnalyzeRecord());
}
